<template>
  <div>
    <el-dialog
      top="10px"
      :lock-scroll="false"
      :visible.sync="formLoading"
      title="发布询价单(询价信息越完整，供应商报价更精准！)"
      class="enquiryDialog"
      width="1200px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
      append-to-body
      modal-append-to-body
    >
      <div class="form-inquiry-price">
        <!--<h4>{{title}}</h4>-->
        <!--<span class="tooltip">询价信息越完整，供应商报价更精准！</span>-->
        <!--<div class="title">发布地区</div>
        <div class="form-item-list">
          <div class="list-item">
            <label class="l-width">*</label>
            <el-select v-model="form.publishProvince" ref="publishProvince" filterable  @change="handleSelectSaleArea" placeholder="请选择">
              <el-option
                v-for="item in addressList"
                :key="item.id"
                :label="item.areaName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="warning-info">注：选择询价单展示的省份地区，切换发布地区后，采购商品信息将清空，请谨慎操作</div>
        </div>-->
        <div class="title">采购商品</div>
        <div class="form-item-list">
          <div class="pro-sort-content">
            <div class="div-table-main">
              <div class="table-list" v-for="t in tdList" :key="t">
                <div class="list-items btn-td">
                  <el-button
                    size="mini"
                    :class="{ gray: tdList.length === 1 }"
                    icon="el-icon-minus"
                    circle
                    @click="delTr(t)"
                    :disabled="tdList.length === 1"
                  ></el-button>
                </div>
                <div class="list-items">
                  <el-cascader
                    class="w-200"
                    ref="proName"
                    :key="cascaderKey1"
                    filterable
                    placeholder="品名"
                    :props="classificationsConfig"
                    separator="/"
                    :options="classificationsOptions"
                    :show-all-levels="false"
                    v-model="selectedOptions[t]"
                    no-data-text=" "
                    @change="sortChange($event, t)"
                  >
                  </el-cascader>
                </div>
                <!--              商品属性-->
                <div class="list-items" v-if="!shangTong[t]">
                  <div
                    v-for="(item, index) in propertyList[t]"
                    :key="index"
                    v-show="propertyList.length"
                  >
                    <el-select
                      v-model="form.attr[`${t}-${item.propertyId}`]"
                      filterable
                      :placeholder="item.name"
                      class="w-140"
                      @change="
                        handleSelectAttr($event, t, item.propertyId, index)
                      "
                    >
                      <el-option
                        v-for="vo in item.data"
                        :key="vo"
                        :label="vo"
                        :value="vo"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <!--              商品品牌-->
                <div class="list-items" v-if="!shangTong[t]">
                  <el-select
                    v-model="form.brandId[t]"
                    filterable
                    @change="handleBrand($event, t)"
                    class="w-140"
                    placeholder="品牌"
                  >
                    <el-option-group
                      v-for="group in brandList[t]"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="item in group.options"
                        :key="item.id"
                        :label="item.brandName"
                        :value="item.id"
                      ></el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <!--              商品单位-->
                <div class="list-items" v-if="!shangTong[t]">
                  <el-select
                    v-model="form.unit[t]"
                    filterable
                    @change="handleUnit($event, t)"
                    class="w-120"
                    placeholder="请选择单位"
                  >
                    <el-option
                      v-for="item in unitList.data"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
                <!--              商砼强度-->
                <div class="list-items" v-if="shangTong[t]">
                  <el-select
                    v-model="form.strongLevel[t]"
                    filterable
                    @change="handleStrong($event, t)"
                    class="w-100"
                    placeholder="强度等级"
                  >
                    <el-option
                      v-for="item in strongFactList[t]"
                      :key="item.strongLevel"
                      :label="item.strongLevel"
                      :value="item.strongLevel"
                    ></el-option>
                  </el-select>
                </div>
                <!--              商砼外加剂-->
                <div class="list-items" v-if="shangTong[t]">
                  <el-cascader
                    class="w-160"
                    :key="cascaderKey2"
                    placeholder="外加剂"
                    :props="{
                      value: 'spec',
                      label: 'admixtureName',
                      multiple: true
                    }"
                    clearable
                    separator="/"
                    :options="admixtureFactList[t]"
                    :show-all-levels="false"
                    v-model="selectedAdmix[t]"
                    no-data-text=" "
                    @change="admixChange($event, t)"
                  >
                  </el-cascader>
                </div>
                <div class="list-items" v-if="shangTong[t]">
                  <el-select
                    v-model="form.config[t]"
                    @change="handleConfig($event, t)"
                    class="w-120"
                  >
                    <el-option label="一级配" :value="1"></el-option>
                    <el-option label="二级配" :value="2"></el-option>
                  </el-select>
                </div>
                <div class="list-items" v-if="shangTong[t]">
                  <el-select
                    v-model="form.deliveryMethod[t]"
                    @change="handleDeliveryMethod($event, t)"
                    class="w-100"
                  >
                    <el-option label="自卸" :value="1"></el-option>
                    <el-option label="泵送" :value="2"></el-option>
                  </el-select>
                </div>
                <!--              采购量-->
                <div class="list-items">
                  <el-input
                    v-model="form.purchaseVol[t]"
                    @change="updatePurchaseNum($event, t)"
                    class="w-120"
                    placeholder="采购量"
                  ></el-input>
                </div>
                <div
                  class="list-items"
                  v-if="shangTong[t]"
                  style="font-size: 14px"
                >
                  立方米
                </div>
              </div>
              <div class="table-list">
                <div style="border: none; text-align: center; flex: 1">
                  <span @click="addMore">
                    <span class="plus">+</span
                    ><span class="more">再加一条</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="title">询价要求</div>
        <div class="form-item-list">
          <el-row>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">报价截止时间：</div>
                <div class="setting-form">
                  <el-date-picker
                    v-model="formParams.deadlineTime"
                    class="w-300"
                    type="datetime"
                    format="yyyy/MM/dd HH:mm:ss"
                    default-time="23:59:59"
                    :picker-options="endDateOpt"
                    placeholder="选择截止时间"
                  >
                  </el-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">收货地：</div>
                <div class="setting-form" style="display: flex">
                  <el-input
                    v-model="formParams.detailAddress"
                    readonly
                    class="w-300"
                    placeholder="请选择收货地"
                  ></el-input>
                  <!--<img style="width:30px;height: 30px;cursor: pointer" src="@/assets/public/map_point.png" @click="showMap" alt="">-->
                  <img
                    style="width:30px;height: 30px;cursor: pointer"
                    src="@/assets/public/map_point.png"
                    @click="myPoint()"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
          </el-row>
          <!--<div class="list-item scroll-receiptAddress">
            <label class="l-width">*</label>
            <el-cascader
              ref="receiptAddress"
              class="w-685"
              :options="addressOptions"
              :props="{ label: 'name', value: 'id' }"
              v-model="form.receiptAddress"
              placeholder="请选择收货地区"
              @change="handleAddress"></el-cascader>
          </div>-->
          <!--<div class="list-item">
            <label class="l-width"></label>
            <el-upload
              :action="action"
              :file-list="fileList"
              list-type="picture-card"
              :limit="1"
              :before-upload="beforeUpload"
              :on-success="uploadSuccess"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed="showWarn"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog
              :visible.sync="dialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :destroy-on-close="true"
            >
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </div>
          <div class="img-tootip">上传参考样品、成品照片等，获得更准确的报价，图片大小≤500kb。</div>-->
          <el-row>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">发票税率(%)：</div>
                <div class="setting-form" style="display: flex">
                  <el-input
                    v-model="formParams.taxRate"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                    placeholder="请输入发票税率"
                    class="w-300"
                  ></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">送货要求：</div>
                <div class="setting-form">
                  <el-radio-group v-model="formParams.deliveryRequire">
                    <el-radio :label="1">自提</el-radio>
                    <el-radio :label="2">供方送货</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">装车要求：</div>
                <div class="setting-form">
                  <el-radio-group v-model="formParams.loadingRequire">
                    <el-radio :label="1">供方承担</el-radio>
                    <el-radio :label="2">需方承担</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="list-item">
                <div class="setting-title start-required">卸车要求：</div>
                <div class="setting-form">
                  <el-radio-group v-model="formParams.unloadRequire">
                    <el-radio :label="1">供方承担</el-radio>
                    <el-radio :label="2">需方承担</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="list-item">
            <div class="setting-title start-required">
              付款方式：
            </div>
            <div class="setting-form">
              <!--<el-radio-group v-model="formParams.payWay">-->
              <el-radio-group v-model="formParams.transactionMethod">
                <el-radio :label="1">预付款</el-radio>
                <el-radio :label="2">货到付款</el-radio>
                <el-radio :label="3">质保金</el-radio>
                <el-radio :label="4">其他</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="list-item">
            <div class="setting-title">
              <el-tooltip
                class="item"
                effect="dark"
                content="公开询价会发布到需求大厅，私密询价仅被邀请供应商可进行报价"
                placement="top-start"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
              公开询价：
            </div>
            <div class="setting-form">
              <el-radio-group v-model="formParams.type">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!--<el-row>-->
          <!--<el-col :span="24">-->
          <div class="list-item" style="align-items: unset">
            <div class="setting-title" style="padding-top:10px;">附件：</div>
            <div class="setting-form">
              <!--<el-button
                    size="small"
                    :loading="formParams.loading"
                    @click="submitUpload(formParams.fileId)"
                  >上传附件</el-button>
                  <div class="img-tootip">可上传不超过20M的文件</div>-->
              <el-upload
                class="upload-demo"
                name="file"
                :headers="{ Authorization: `Bearer ${token}` }"
                :action="uploadUrl"
                :accept="accept"
                :before-upload="beforeUpload"
                :on-error="onError"
                :on-success="onSuccess"
                :on-remove="onRemove"
                :limit="1"
                style="width: 600px;"
              >
                <el-button :loading="imgLoad">上传文件</el-button>
                <span
                  slot="tip"
                  class="el-upload__tip"
                  style="margin-left:20px;"
                >
                  支持格式：.rar.zip.doc.docx.pdf.jpg ，单个文件不能超过20MB
                </span>
              </el-upload>
            </div>
          </div>
          <!--</el-col>-->
          <!--</el-row>-->
          <!--<div v-if="formParams.filePath">
            <el-row>
              <el-col :span="24">
                <div
                  v-for="(item,ind) in formParams.filePath"
                  :key="ind"
                  @click="down(item)"
                  class="down fileStyle"
                >附件{{ind+1}}</div>
              </el-col>
            </el-row>
          </div>-->
          <div class="list-item">
            <div class="setting-title">备注：</div>
            <el-input
              type="textarea"
              v-model="formParams.describe"
              rows="3"
              class="w-685"
              maxlength="300"
              show-word-limit
              placeholder="你可以填写更多补充说明，如质量要求，用途，性能等"
            ></el-input>
          </div>
        </div>
        <!--<div class="title">要求设置</div>
        <div class="form-item-list">
          <div class="list-item">
            <div class="setting-title">
              <el-tooltip class="item" effect="dark" content="公开询价会发布到需求大厅，私密询价仅被邀请供应商可进行报价" placement="top-start">
                <i class="el-icon-question"></i>
              </el-tooltip>
              询价方式：
            </div>
            <div class="setting-form">
              <el-radio-group v-model="formParams.type">
                <el-radio :label="1">公开询价</el-radio>
                <el-radio :label="2">私密询价</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="list-item">
            <div class="setting-title">
              报价形式：
            </div>
            <div class="setting-form">
              <el-checkbox-group v-model="form.check" @change="handleQuotationMethod">
                <el-checkbox :label="1">报价含税</el-checkbox>
                <el-checkbox :label="2">报价含运费</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="list-item">
            <div class="setting-title start-required">
              收货日期：
            </div>
            <div class="setting-form">
              <el-date-picker
                v-model="formParams.receivingTime"
                type="date"
                format="yyyy/MM/dd HH:mm:ss"
                :picker-options="receivingTimeDateOpt"
                placeholder="选择收货日期">
              </el-date-picker>
            </div>
          </div>
          <div class="list-item">
            <div class="setting-title">
              交易方式：
            </div>
            <div class="setting-form">
              <el-radio-group v-model="formParams.transactionMethod">
                <el-radio :label="1">现款现货</el-radio>
                <el-radio :label="2">货到付款</el-radio>
                <el-radio :label="3">账期支付</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>-->
        <div class="title">联系信息</div>
        <div class="form-item-list">
          <div class="list-item" v-if="userInfo.companyName">
            <div class="setting-title">
              发布企业：
            </div>
            <span>{{ userInfo.companyName }}</span>
          </div>
          <div class="list-item">
            <label class="l-width">*</label>
            <el-input
              v-model="formParams.contacts"
              class="w-300"
              maxlength="16"
              placeholder="请填写姓名"
            ></el-input>
            <el-input
              v-model="formParams.contactNumber"
              maxlength="11"
              @blur="checkPhone"
              class="w-300"
              placeholder="请填写电话"
            ></el-input>
          </div>
        </div>
        <div class="title">邀请供应商</div>
        <div class="form-item-list">
          <div class="list-item">
            <label class="l-width" v-show="formParams.type == 2">*</label>
            <label class="l-width" v-show="formParams.type == 1"></label>
            <el-select
              v-model="form.shop"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              @clear="handleClear"
              :loading="loading"
            >
              <el-option
                v-for="item in shopOptionList"
                :key="item.no"
                :label="item.name"
                :value="item.no"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              @click="addShop"
              style="margin-left: 10px;"
            >
              添加供应商
            </el-button>
          </div>
        </div>
        <div class="form-item-list">
          <el-table
            :data="shopList"
            border
            :header-cell-style="setColumnDataColor"
            :cell-style="setCellStyle"
            empty-text=" "
          >
            <template slot="empty" v-if="!shopList.length">
              暂无数据
            </template>
            <el-table-column prop="name" label="供应商名称"></el-table-column>
            <el-table-column width="160" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="delShop(scope.$index)"
                  v-show="!scope.row.id"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="form-item-list" style="text-align: center">
          <el-button @click="closeForm">取消</el-button>
          <el-button type="primary" @click="onSubmit" :loading="subLoading">
            发布询价单
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="submit-dialog"
      title="温馨提示"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="addSuccessDialogVisible"
      width="30%"
      @close="sendSuccess"
    >
      <div>
        <i class="el-icon-success"></i>
        <span>询价发布成功，耐心等待商家报价</span>
      </div>
      <!--<span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goDetail">查看详情</el-button>
      </span>-->
    </el-dialog>
    <!--    地图map-->
    <el-dialog
      class="map-dialog"
      :visible.sync="mapVisible"
      width="1200px"
      :before-close="() => (mapVisible = false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="!isFullScreen"
    >
      <map-address
        v-if="mapVisible"
        :positionAddress="positionAddress"
        :type="1"
        @close="() => (mapVisible = false)"
        @setPosition="getPosition"
      />
    </el-dialog>
  </div>
</template>

<script>
import cookie from "@/storage/cookies"
// import axios from "@/http"
import moment from "moment"
import { Unit } from "./Unit"
import { setColumnDataColor, setCellStyle } from "@/components/table/style"
import { apiInquiryPrice } from "@/api/apiInquiryPrice"
// import MapAddress from "@/components/map/ResMapAddress"
import { fnc } from "./fnc"
const uploadUrl = process.env.VUE_APP_APIUSER
export default {
  name: "SaveInquiryPrice",
  components: {
    // MapAddress
  },
  props: {
    enquiryDetails: {
      type: Object
    },
    formLoading: {
      type: Boolean
    }
  },
  data() {
    return {
      centerValue: {
        lng: "",
        lat: ""
      },
      center: [104.04522, 30.54698],
      positionAddress: {},
      isFullScreen: false,
      imgLoad: false,
      token: cookie.cookieRead("token"),
      // uploadUrl: env[process.env.environment].VUE_APP_PERSONURL + '/file/add',
      uploadUrl: uploadUrl + "/file/add",
      accept: ".rar,.zip,.doc,.docx,.pdf,.jpg",
      selectfileId: "",
      OwnAddress: {
        lng: 0,
        lat: 0
      },
      setColumnDataColor,
      setCellStyle,
      mapVisible: false,
      formType: 0, // 0 新增 1 编辑用户中心 2编辑pc商品 3编辑pc商砼
      title: "发布询价单",
      addSuccessDialogVisible: false,
      // action: process.env.VUE_APP_APIUSER + '/file/add',
      form: {
        publishProvince: "",
        publishProvinceName: "",
        radio: 1,
        check: [],
        shop: "",
        purchaseVol: [],
        brandId: [],
        strongLevel: [],
        unit: [],
        attr: {},
        config: [],
        deliveryMethod: []
      },
      loading: false,
      subLoading: false,
      shopOptionList: [{}],
      shopList: [],
      brandList: [],
      propertyList: [],
      unitList: [],
      addressList: [],
      shangTong: [],
      classificationsOptions: [],
      admixtureFactList: [],
      strongFactList: [],
      tdList: [0],
      addressOptions: [],
      classificationsConfig: {
        value: "id",
        label: "name"
      },
      dialogImageUrl: "",
      selectedOptions: [],
      selectedAdmix: [],
      cascaderKey1: 0,
      cascaderKey2: 0,
      dialogVisible: false,
      formParams: {
        cityName: "",
        cityNo: "",
        concreteList: [],
        contactNumber: "",
        contacts: "",
        deadlineTime: "",
        describe: "",
        districtName: "",
        districtNo: "",
        id: 0,
        img: "",
        // "inviteCompany": "",
        itemList: [],
        provinceName: "",
        provinceNo: "",
        publishProvince: "",
        quotationMethod: "",
        receivingTime: "",
        transactionMethod: 1,
        type: 2,
        detailAddress: "",
        latitude: 0,
        longitude: 0,
        taxRate: "",
        deliveryRequire: 1,
        loadingRequire: 1,
        unloadRequire: 1,
        // payWay: 1,
        // filePath: [],
        filePath: "",
        inviteCompanyList: []
      },
      formValidate: false,
      phoneValidate: true,
      numValidate: true,
      areaListThree: [],
      // fileList: [],
      fileList: "",
      endDateOpt: {
        disabledDate: time => {
          let time1 = moment(time.getTime()).format("YYYY/MM/DD HH:mm:ss")
          let time2 = moment(Date.now())
            .subtract(1, "days")
            .format("YYYY/MM/DD HH:mm:ss")
          return time1 < time2
        }
      },
      receivingTimeDateOpt: {
        disabledDate: time => {
          let time1 = moment(time.getTime()).format("YYYY/MM/DD HH:mm:ss")
          let time2 = moment(Date.now())
            .subtract(1, "days")
            .format("YYYY/MM/DD HH:mm:ss")
          return time1 < time2
        }
      },
      detailId: "",
      details: {},
      detailPc: {}
    }
  },
  watch: {
    tdList: {
      handler(newVal, oldVal) {},
      immediate: true,
      deep: true
    },
    enquiryDetails: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.detailPc = JSON.parse(JSON.stringify(newVal))
          this.pcInit()
        }
      },
      immediate: true,
      deep: true
    },
    "formParams.deadlineTime": function(newVal) {
      /* let timeStr = '23:59:59'
        let nowStr = moment(newVal).format('YYYY/MM/DD')
        // if(moment(Date.now()).date() == moment(newVal).date()){
        //   timeStr = moment(Date.now()).format('HH:mm:ss')
        // } else {
        //   timeStr = '23:59:59'
        // }
        this.formParams.deadlineTime = nowStr + ' ' + timeStr */
    },
    "formParams.receivingTime": function(newVal) {
      //   let timeStr = "23:59:59"
      //   let nowStr = moment(newVal).format("YYYY/MM/DD")
      // this.formParams.receivingTime = nowStr + ' ' + timeStr
    }
  },
  methods: {
    sendSuccess() {
      this.addSuccessDialogVisible = false
      this.closeForm()
    },
    closeForm() {
      this.resetForm()
      this.$emit("closeInquiryPriceDialog")
    },
    resetForm() {
      this.tdList = [0]
      this.form = {
        publishProvince: "",
        publishProvinceName: "",
        radio: 1,
        check: [],
        shop: "",
        purchaseVol: [],
        brandId: [],
        strongLevel: [],
        unit: [],
        attr: {},
        config: [],
        deliveryMethod: []
      }
      this.shopList = []
      this.formParams = {
        cityName: "",
        cityNo: "",
        concreteList: [],
        contactNumber: "",
        contacts: "",
        // "deadlineTime": "",
        describe: "",
        districtName: "",
        districtNo: "",
        id: 0,
        img: "",
        // "inviteCompany": "",
        itemList: [],
        provinceName: "",
        provinceNo: "",
        publishProvince: "",
        quotationMethod: "",
        receivingTime: "",
        transactionMethod: 1,
        type: 2,
        detailAddress: "",
        latitude: 0,
        longitude: 0,
        taxRate: "",
        deliveryRequire: 1,
        loadingRequire: 1,
        unloadRequire: 1,
        // payWay: 1,
        // filePath: [],
        filePath: "",
        inviteCompanyList: []
      }
    },
    submitUpload(val) {
      this.selectfileId = val
    },
    async myPoint() {
      this.mapVisible = true
    },
    getPosition(obj, center) {
      this.$set(this.centerValue, "lng", obj.point.lng)
      this.$set(this.centerValue, "lat", obj.point.lat)
      this.positionAddress = obj
      // this.getCity()
      this.center = center
      this.formParams.detailAddress = this.positionAddress.value
      if (this.center) {
        this.formParams.longitude = this.center[0]
        this.formParams.latitude = this.center[1]
      }
      // this.handleTab(this.tabType)
    },
    close() {
      this.mapVisible = false
    },
    closeDialog() {
      this.resetForm()
      this.$emit("closeInquiryPriceDialog")
    },
    // 获取发布地区列表
    // async setProvinceNoOptions () {
    //   let res = await apiHome.getCurrentProvince()
    //   this.addressList = res.data.data
    // },
    // 获取分类
    async getClassificationsData() {
      let res = await apiInquiryPrice.getProducts()
      ++this.cascaderKey1
      if (res.data && res.data.length > 0) {
        this.classificationsOptions = res.data
      } else {
        this.classificationsOptions = []
      }
      // 编辑-初始化
      /* if(this.formType === 1){
          this.$nextTick(()=>{
            this.init()
          })
        }
        if(this.formType === 2 || this.formType === 3){
          this.$nextTick(()=>{
            this.pcInit()
          })
        } */
    },
    // 获取品牌信息
    async getBrandData(id, idx) {
      let res = await apiInquiryPrice.fetchBrand(id)
      // this.brandList[idx] = res.data.data
      this.$set(this.brandList, idx, res.data.data)
    },
    // 获取属性选择
    async getProperty(id, idx) {
      if (JSON.stringify(this.form.attr) !== "{}") {
        for (let i in this.form.attr) {
          let index = i.split("-")
          if (index === idx) {
            delete this.form.attr[i]
          }
        }
      }
      let res = await fnc.getProperty(id)
      this.$set(this.propertyList, idx, res)
    },
    // 获取单位
    async getUnitListData() {
      let res = await apiInquiryPrice.fetchUnit()
      this.unitList = res.data
    },
    // 获取强度列表
    async getLevetData(idx) {
      let business = await apiInquiryPrice.concreteStrongAll()
      this.$set(this.strongFactList, idx, business.data.result)
    },
    // 获取外加剂列表
    async getAdditiveData(idx) {
      let business = await apiInquiryPrice.concreteAdmixtureAll()
      let data = this.setGroup(business.data.result)
      ++this.cascaderKey2
      this.$set(this.admixtureFactList, idx, data)
    },
    // 外加剂选择
    admixChange(value, idx) {
      if (!value) {
        return
      }
      this.formParams.itemList[idx].admixtureFactList = []
      if (value.length) {
        value.forEach((item, index) => {
          if (item.length === 1) {
            this.formParams.itemList[idx].admixtureFactList.push({
              admixtureName: item[0],
              // admixtureName: item[0].admixtureName,
              spec: ""
            })
          } else if (item.length === 2) {
            this.formParams.itemList[idx].admixtureFactList.push({
              admixtureName: item[1].split("-")[0],
              spec: item[1].split("-")[1]
            })
          }
        })
      }
    },
    // 选择发布地区
    handleSelectSaleArea(id) {
      let obj = this.addressList.find(vo => vo.id === id)
      this.formParams.publishProvince = obj.id
      this.formParams.publishProvinceName = obj.areaName

      this.form.brandId = []
      this.form.attr = {}
      this.form.unit = []
      this.form.config = []
      this.form.deliveryMethod = []
      this.form.purchaseVol = []
      this.form.strongLevel = []
      this.propertyList = []

      this.selectedOptions = []
      this.admixtureFactList = []
      this.strongFactList = []
      this.brandList = []
      this.propertyList = []
      this.selectedAdmix = []
      this.formParams.concreteList = []
      this.formParams.itemList = []
      this.phoneValidate = true
      this.numValidate = true
      this.tdList = [0]
      this.formType = 0
      this.classificationsOptions = [{}]
      this.$nextTick(() => {
        this.getClassificationsData(id)
      })
    },
    // 选择分类
    sortChange(value, idx) {
      if (!value) {
        return
      }
      this.form.brandId[idx] = ""
      this.form.unit[idx] = ""
      this.form.purchaseVol[idx] = ""

      let catObj = this.getCatLabel(this.classificationsOptions, value)
      if (catObj.fcatName === "商砼") {
        this.propertyList[idx] = null
        this.formParams.itemList[idx] = null
      } else {
        this.admixtureFactList[idx] = []
        this.strongFactList[idx] = []
        this.selectedAdmix[idx] = []
      }
      this.classificationsOptions.forEach(item => {
        if (item.id === value[0]) {
          if (item.name === "商砼") {
            this.formParams.itemList[idx] = {}
            this.formParams.itemList[idx] = catObj
            this.formParams.itemList[idx].sort = idx
            this.shangTong[idx] = item
            this.form.unit[idx] = "立方米"
            this.formParams.itemList[idx].unit = "立方米"
            this.getLevetData(idx)
            this.getAdditiveData(idx)
            this.form.config[idx] = 2
            this.form.deliveryMethod[idx] = 1
            this.formParams.itemList[idx].deliveryMethod = 1
            this.formParams.itemList[idx].config = 2
          } else {
            // if(!this.formParams.itemList[idx] || JSON.stringify(this.formParams.itemList[idx]) === '{}'){
            //   this.formParams.itemList[idx] = {}
            // }
            this.formParams.itemList[idx] = {}
            this.formParams.itemList[idx].fcategory = catObj.fcategory
            this.formParams.itemList[idx].fcatName = catObj.fcatName
            this.formParams.itemList[idx].scategory = catObj.scategory
            this.formParams.itemList[idx].scatName = catObj.scatName
            this.formParams.itemList[idx].tcategory = catObj.tcategory
            this.formParams.itemList[idx].tcatName = catObj.tcatName
            this.formParams.itemList[idx].attrList = []
            this.formParams.itemList[idx].sort = idx

            this.shangTong[idx] = ""
            this.getBrandData(value[value.length - 1], idx) // 获取品牌选择分类
            this.getProperty(value[value.length - 1], idx) // 获取属性选择分类
          }
        }
      })
    },
    // 选择属性
    handleSelectAttr(value, idx, pId, i) {
      this.$set(this.form, `attr[${idx}-${pId}]`, value)
      let obj = this.propertyList[idx].find(item => item.propertyId === pId)
      let valIndex = obj.data.indexOf(value)
      //   let _index = idx
      if (!this.formParams.itemList[idx].attrList[i]) {
        this.formParams.itemList[idx].attrList[i] = {}
      }
      this.formParams.itemList[idx].attrList[i].paramId = obj.propertyId
      this.formParams.itemList[idx].attrList[i].paramName = obj.name
      this.formParams.itemList[idx].attrList[i].paramValId = obj.id[valIndex]
      this.formParams.itemList[idx].attrList[i].paramValName = value
    },
    // 选择品牌
    handleBrand(value, idx) {
      if (!value) {
        return
      }
      let obj = {}
      if (this.brandList[idx] && this.brandList[idx].length) {
        for (let i = 0; i < this.brandList[idx].length; i++) {
          obj = this.brandList[idx][i].options.find(v => v.id === value)
          if (obj && obj.id) {
            break
          }
        }
        if (JSON.stringify(obj) === "{}") {
          return
        }
        this.form.brandId[0] = value
        this.formParams.itemList[idx].brandId = obj.id
        this.formParams.itemList[idx].brandName = obj.brandName
      }
    },
    // 选择商砼强度
    handleStrong(value, idx) {
      this.formParams.itemList[idx].strongLevel = value
    },
    // 设置采购量
    updatePurchaseNum(val, idx) {
      let value = Number(val)
      if (!this.form.unit[idx]) {
        this.$message({
          message: "请先选择单位",
          type: "warning"
        })
        return
      }
      let obj = Unit(this.form.unit[idx])
      if (isNaN(value)) {
        this.$message({
          message: "请输入数字",
          type: "warning"
        })
        return
      }
      if (value < obj.min || value > obj.max) {
        this.$message({
          message: `采购量在${obj.min}~${obj.max}之间`,
          type: "warning"
        })
        this.numValidate = false
        return
      }
      this.numValidate = true
      this.formParams.itemList[idx].num = value
    },
    // 选择单位
    handleUnit(value, idx) {
      this.formParams.itemList[idx].unit = value
    },
    // 选择商砼服务
    handleDeliveryMethod(value, idx) {
      this.formParams.itemList[idx].deliveryMethod = value
    },
    // 选择商砼配置
    handleConfig(value, idx) {
      this.formParams.itemList[idx].config = value
    },
    // 获取分类label
    getCatLabel(arr, ids) {
      let obj = {}
      if (ids && ids[0]) {
        let parent = arr.find(p => p.id === ids[0])
        let childOne = {}
        let childTwo = {}
        if (parent && parent.children && parent.children.length && ids[1]) {
          childOne = parent.children.find(child => child.id === ids[1])
          if (childOne.children && childOne.children.length && ids[2]) {
            childTwo = childOne.children.find(c => c.id === ids[2])
          }
        }
        obj.fcategory = parent.id
        obj.fcatName = parent.name
        obj.scategory = childOne.id
        obj.scatName = childOne.name
        obj.tcategory = childTwo.id
        obj.tcatName = childTwo.name
      }
      return obj
    },
    // 数据分组
    setGroup(arr) {
      let dataInfo = {}
      arr.forEach((item, index) => {
        let { admixtureName } = item
        if (!dataInfo[admixtureName]) {
          dataInfo[admixtureName] = {
            admixtureName: item.admixtureName,
            spec: item.admixtureName,
            children: []
          }
        }
        if (item.spec && item.admixtureName) {
          dataInfo[admixtureName].children.push({
            admixtureName: item.admixtureName + "-" + item.spec,
            spec: item.admixtureName + "-" + item.spec
          })
        } else {
          dataInfo[admixtureName].children = null
        }
      })
      let list = Object.values(dataInfo)
      return list
    },
    // 删除分类
    delTr(key) {
      this.form.brandId[key] = []
      this.brandList[key] = []
      this.selectedOptions[key] = []
      this.admixtureFactList[key] = []
      this.strongFactList[key] = []
      this.selectedAdmix[key] = []
      this.propertyList[key] = null
      this.formParams.itemList[key] = null
      // this.propertyList.splice(key, 1)
      // this.formParams.itemList.splice(key, 1)
      this.tdList.splice(this.tdList.indexOf(key), 1)
    },
    // 添加一行
    addMore() {
      this.tdList.push(this.tdList[this.tdList.length - 1] + 1)
    },
    // 选择收货地区
    handleAddress(value) {
      let parent = this.addressOptions.find(item => item.id === value[0])
      let child2 = parent.children.find(item => item.id === value[1])
      let child3 = child2.children.find(item => item.id === value[2])
      this.formParams.provinceNo = parent.id
      this.formParams.provinceName = parent.name
      this.formParams.cityNo = child2.id
      this.formParams.cityName = child2.name
      this.formParams.districtNo = child3.id
      this.formParams.districtName = child3.name
    },
    // 文件上传
    beforeUpload(file) {
      this.imgLoad = true
      let FileExt = file.name.replace(/.+\./, "")
      let isLt2M = file.size / 1024 / 1024 < 20
      if ("rar,zip,doc,docx,pdf,jpg".indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: "warning",
          message: "请上传后缀名为.rar.zip.doc.docx.pdf.jpg的附件！"
        })
        this.imgLoad = false
        return false
      }
      if (!isLt2M) {
        this.$message({
          type: "warning",
          message: "上传文件大小不能超过 20MB!"
        })
        this.imgLoad = false
        return false
      }
    },
    onError(err, file, fileList) {
      let error = String(err)
      error = error.slice(error.indexOf("{"), error.length)
      error = JSON.parse(error)
      this.formParams.filePath = []
      // this.formParams.filePath = '';
      this.imgLoad = false
      this.$message.error(error.msg)
    },
    onSuccess(response, file, fileList) {
      if (response.code === "1") {
        this.$message.error(response.msg)
      } else {
        // this.formParams.filePath.push({
        //   name: file.name,
        //   fileUrl: file.response
        // });
        this.formParams.filePath = file.response.data
        this.imgLoad = false
        this.$message.success("上传成功！")
      }
    },
    onRemove(file, fileList) {
      this.formParams.filePath = fileList
      // this.formParams.filePath = '';
    },
    // 图片上传前校验
    /* beforeUpload(file){
        const isJPG = file.type === 'image/jpeg'
        const isJPG2 = file.type === 'image/png'
        const isJPG3 = file.type === 'image/jpg'
        const isJPG4 = file.type === 'image/bmp'
        const isLt500Kb = (file.size / 1024) < 500

        if (!(isJPG || isJPG2 || isJPG3 || isJPG4)) {
          this.$message.error('上传的图片格式不支持，请上传.bmp .png .jpg .jpeg格式')
        }
        if (!isLt500Kb) {
          this.$message.error('上传图片大小不能超过500kb')
        }
        return (isJPG || isJPG2 || isJPG3 || isJPG4) && isLt500Kb
      }, */
    // 图片上传成功
    /* uploadSuccess(response, file, fileList){
        this.descImg = response.data
        this.formParams.img = this.descImg
      }, */
    /* handleRemove(file, fileList) {
      }, */
    // 预览图片
    /* handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }, */
    // 选择报价形式
    handleQuotationMethod(value) {
      this.formParams.quotationMethod = value.join(",")
    },
    showWarn() {
      this.$message({
        message: "只能上传一张图片",
        type: "warning"
      })
    },
    // 查询供应商
    remoteMethod(query) {
      if (query !== "") {
        this.shopOptionList = []
        this.loading = true
        let nos = []
        if (this.shopList.length) {
          this.shopList.forEach(item => {
            nos.push(item.no)
          })
        }
        nos.push(this.userInfo.companyNo)
        let params = {
          name: query,
          nos: nos
        }
        setTimeout(async () => {
          // 搜索接口
          let res = await apiInquiryPrice.searchCompany(params)
          this.shopOptionList = res.data.data
          this.loading = false
        }, 0)
      } else {
        this.shopOptionList = []
      }
    },
    handleClear() {
      this.form.shop = ""
      this.shopOptionList = []
    },
    // 添加供应商
    addShop() {

      if (!this.form.shop) {
        return
      }
      let list = this.shopOptionList.find(item => item.no === this.form.shop)
      let checkList = this.shopList.find(item => item.no === this.form.shop)
      if (checkList && checkList.no) {
        this.$message({
          message: "已添加过该供应商，请选择其它供应商",
          type: "warning"
        })
        return
      }
      this.formParams.inviteCompanyList.push({
        provinceNo: list.provinceNo,
        provinceName: list.provinceName,
        supplier: list.no,
        supplierName: list.name
      })
      this.shopList.push(list)
      this.handleClear()
    },
    // 删除供应商
    delShop(index) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.shopList.splice(index, 1)
          this.formParams.inviteCompanyList.splice(index, 1)
        })
        .catch(() => {})
    },
    // 获取三级地址列表
    // async getAllAreaList() {
    //   let res = await apiMemberApply.getAreas()
    //   this.addressOptions = this.getTreeList(res.data.data)
    // },
    // 递归方法
    getTreeList(data) {
      // 循环遍历json数据
      for (let i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeList(data[i].children)
        }
      }
      return data
    },
    checkPhone(value) {
      if (!/^1[3456789]\d{9}$/.test(value.target.value)) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        })
        this.phoneValidate = false
      } else {
        this.phoneValidate = true
      }
    },
    // 提交保存
    onSubmit() {
      // if(!this.formParams.publishProvince || !this.formParams.publishProvinceName){
      //   this.$message({
      //     message: '请选择发布地区',
      //     type: 'warning'
      //   });
      //   return
      // }

      if (!this.formParams.itemList.length) {
        this.$message({
          message: "请选择采购商品",
          type: "warning"
        })
        return
      } else {
        for (let i = 0; i < this.formParams.itemList.length; i++) {
          if (
            this.formParams.itemList[i] &&
            !JSON.stringify(this.formParams.itemList[i]) !== "{}"
          ) {
            if (
              !this.formParams.itemList[i].fcategory ||
              !this.formParams.itemList[i].scategory ||
              !this.formParams.itemList[i].tcategory
            ) {
              this.$message({
                message: "商品分类不能为空",
                type: "warning"
              })
              return
            }
            if (
              this.propertyList[i] &&
              this.formParams.itemList[i] &&
              this.formParams.itemList[i].attrList
            ) {
              if (
                this.formParams.itemList[i].attrList.length !==
                this.propertyList[i].length
              ) {
                this.$message({
                  message: "商品属性未选择完善",
                  type: "warning"
                })
                return
              }
            }
            if (this.formParams.itemList[i].fcatName === "商砼") {
              if (!this.formParams.itemList[i].strongLevel) {
                this.$message({
                  message: "商砼强化等级未选择",
                  type: "warning"
                })
                return
              }
              if (
                !this.formParams.itemList[i].admixtureFactList ||
                !this.formParams.itemList[i].admixtureFactList.length
              ) {
                this.$message({
                  message: "商砼外加剂未选择",
                  type: "warning"
                })
                return
              }
              if (!this.formParams.itemList[i].config) {
                this.$message({
                  message: "商砼配置未选择",
                  type: "warning"
                })
                return
              }
              if (!this.formParams.itemList[i].deliveryMethod) {
                this.$message({
                  message: "商砼服务未选择",
                  type: "warning"
                })
                return
              }
            }

            if (!this.formParams.itemList[i].unit) {
              this.$message({
                message: "请选择计量单位",
                type: "warning"
              })
              return
            }
            if (!this.numValidate || !this.formParams.itemList[i].num) {
              this.$message({
                message: "请输入采购量或输入不正确",
                type: "warning"
              })
              return
            }
          }
        }
      }
      /* if(!this.formParams.provinceNo || !this.formParams.cityNo || !this.formParams.districtNo){
          this.$message({
            message: '请选择收货地区',
            type: 'warning'
          });
          return
        } */
      if (!this.formParams.detailAddress) {
        this.$message({
          message: "请选择收货地",
          type: "warning"
        })
        return
      }
      if (!this.formParams.deadlineTime) {
        this.$message({
          message: "报价截止时间不能为空",
          type: "warning"
        })
        return
      }
      if (!this.formParams.taxRate) {
        this.$message({
          message: "发票税率不能为空",
          type: "warning"
        })
        return
      } else if (parseFloat(this.formParams.taxRate) > 100) {
        this.$message({
          message: "发票税率不能大于100%",
          type: "warning"
        })
        return
      }
      /* if(!this.formParams.receivingTime){
          this.$message({
            message: '收货日期不能为空',
            type: 'warning'
          });
          return
        } */
      if (
        !this.formParams.contacts ||
        !this.formParams.contactNumber ||
        !this.phoneValidate
      ) {
        this.$message({
          message: "联系信息姓名或手机号不能为空或手机号格式错误",
          type: "warning"
        })
        return
      }
      if (this.formParams.type === 2) {
        if (!this.formParams.inviteCompanyList.length) {
          this.$message({
            message: "请添加您要邀请的供应商",
            type: "warning"
          })
          return
        }
      }

      let newList = this.formParams.itemList.filter(item => item !== null)
      for (let i = 0; i < newList.length; i++) {
        newList[i].sort = i
      }
      let obj = {
        concreteList: []
      }
      for (let i = 0; i < newList.length; i++) {
        if (newList[i] && newList[i].fcatName === "商砼") {
          obj.concreteList.push(newList[i])
        }
      }

      this.formParams.deadlineTime = Number(this.formParams.deadlineTime)
      this.formParams.publishUserName = this.userInfo.realName
      let { ...params } = { ...this.formParams }
      params.concreteList = obj.concreteList
      params.itemList = newList.filter(item => item.fcatName !== "商砼")
      this.subLoading = true
      this.$nextTick(async () => {
        let res = await apiInquiryPrice.savePublish(params)
        if (res.data.code === 200) {
          this.detailId = res.data.data
          this.subLoading = false
          this.addSuccessDialogVisible = true
        } else {
          // for(let i= 0;i<this.formParams.concreteList.length;i++){
          //   this.formParams.itemList.splice(this.formParams.concreteList[i].sort, 0, this.formParams.concreteList[i])
          //   this.formParams.concreteList.splice(i, 1)
          // }
          this.subLoading = false
          this.$message({
            message: res.data.msg,
            type: "error"
          })
        }
      })
    },
    delEmpty(arr) {
      let newArr = arr
      for (let i = 0; i < newArr.length; i++) {
        if (!newArr[i]) {
          newArr.splice(i, 1)
        }
      }
      return newArr
    },
    // 获取详情数据
    async getDetailData() {
      let res = await apiInquiryPrice.getDetail(this.detailId)
      if (res.data.code === 200) {
        this.details = res.data.data
        // this.getClassificationsData(this.details.publishProvince)
      }
    },
    goDetail() {
      this.$router.push({
        path: "/InquiryPriceDetail",
        query: { no: this.detailId }
      })
    },
    // 分类数据初始化排序
    sort(arr) {
      let newArr = []
      arr.forEach((item, index) => {
        newArr.splice(item.sort, 0, item)
      })
      return newArr
    },
    // 用户中心-编辑-初始化
    init() {
      let { ...initData } = this.details
      let [...proAttr] = [
        ...this.details.itemList,
        ...this.details.concreteList
      ]
      let arrs = this.sort(proAttr)
      this.tdList = []
      for (let i = 0; i < arrs.length; i++) {
        this.tdList.push(i)
        let category = [arrs[i].fcategory, arrs[i].scategory, arrs[i].tcategory]
        this.selectedOptions[arrs[i].sort] = category
        this.sortChange(category, i)
        this.form.purchaseVol[arrs[i].sort] = arrs[i].num
        this.form.brandId[arrs[i].sort] = arrs[i].brandId
        this.form.unit[arrs[i].sort] = arrs[i].unit
        this.handleUnit(arrs[i].unit, arrs[i].sort)
        this.updatePurchaseNum(arrs[i].num, arrs[i].sort)
        if (arrs[i].fcatName !== "商砼") {
          if (arrs[i].attrList && arrs[i].attrList.length) {
            arrs[i].attrList.forEach((attr, index) => {
              this.form.attr[`${arrs[i].sort}-${attr.paramId}`] =
                attr.paramValName
              this.formParams.itemList[arrs[i].sort].attrList.push({
                paramId: attr.paramId,
                paramName: attr.paramName,
                paramValId: attr.paramValId,
                paramValName: attr.paramValName
              })
            })
          }
        } else {
          this.form.strongLevel[arrs[i].sort] = arrs[i].strongLevel
          this.form.config[arrs[i].sort] = arrs[i].config
          this.form.deliveryMethod[arrs[i].sort] = arrs[i].deliveryMethod
          if (arrs[i].admixtureFactList && arrs[i].admixtureFactList) {
            let admix = []
            arrs[i].admixtureFactList.forEach((attr, index) => {
              if (!attr.spec) {
                admix[index] = [attr.admixtureName]
              } else {
                admix[index] = [
                  attr.admixtureName,
                  attr.admixtureName + "-" + attr.spec
                ]
              }
            })
            this.$set(this.selectedAdmix, arrs[i].sort, admix)
            this.admixChange(admix, arrs[i].sort)
          }
          this.handleStrong(arrs[i].strongLevel, arrs[i].sort)
          this.handleConfig(arrs[i].config, arrs[i].sort)
          this.handleDeliveryMethod(arrs[i].deliveryMethod, arrs[i].sort)
        }
      }

      // this.form.publishProvince = Number(initData.publishProvince)
      this.form.radio = initData.type
      let check = initData.quotationMethod
        ? initData.quotationMethod.split(",")
        : []
      this.formParams.quotationMethod = initData.quotationMethod
      // this.formParams.publishProvince = initData.publishProvince
      // this.formParams.publishProvinceName = initData.publishProvinceName
      this.formParams.provinceNo = initData.provinceNo
      this.formParams.provinceName = initData.provinceName
      this.formParams.cityNo = initData.cityNo
      this.formParams.cityName = initData.cityName
      this.formParams.districtNo = initData.districtNo
      this.formParams.districtName = initData.districtName
      // this.formParams.transactionMethod = initData.transactionMethod
      this.formParams.inviteCompanyList = initData.inviteCompanyList
      if (check.length > 1) {
        this.form.check = [Number(check[0]), Number(check[1])]
      } else if (check.length === 1) {
        this.form.check.push(Number(check[0]))
      }
      // this.form.receiptAddress = [Number(initData.provinceNo), Number(initData.cityNo), Number(initData.districtNo)]
      this.formParams.describe = initData.describe
      this.formParams.img = initData.img
      this.formParams.id = initData.id
      this.formParams.no = this.detailId
      this.dialogImageUrl = initData.img
      // if(initData.img){
      //   this.fileList.push({
      //     name: 'desc.png',
      //     url: initData.img
      //   })
      // }
      this.formParams.type = initData.type
      this.formParams.deadlineTime = initData.deadlineTime
      this.formParams.receivingTime = initData.receivingTime
      this.formParams.contacts = initData.contacts
      this.formParams.contactNumber = initData.contactNumber
      if (initData.inviteCompanyList.length) {
        initData.inviteCompanyList.forEach(item => {
          this.shopList.push({
            id: item.id,
            no: item.supplier,
            name: item.supplierName,
            provinceNo: item.provinceNo,
            provinceName: item.provinceName
          })
        })
      }
      // this.formLoading = false
    },
    // PC-编辑-初始化
    pcInit() {
      this.tdList = [0]
      let category = [
        this.detailPc.fcategory,
        this.detailPc.scategory,
        this.detailPc.tcategory
      ]
      this.selectedOptions[0] = category
      this.sortChange(category, 0)


      this.formParams.contacts = this.userInfo.realName
      this.formParams.contactNumber = this.userInfo.telPhone

      // this.formParams.publishProvince = this.detailPc.publishProvince
      // this.formParams.publishProvinceName = this.detailPc.publishProvinceName
      if (this.detailPc.inviteCompanyList) {
        this.formParams.inviteCompanyList = this.detailPc.inviteCompanyList
      } else {
        this.formParams.inviteCompanyList = []
      }
      // this.formParams.type = 2
      if (this.detailPc.type) {
        this.formParams.type = this.detailPc.type
      } else {
        this.formParams.type = 2
      }
      // 发票税率
      if (this.detailPc.taxRate) {
        this.formParams.taxRate = this.detailPc.taxRate
      }
      this.form.purchaseVol[0] = this.detailPc.num
      this.form.brandId[0] = this.detailPc.brandId
      this.form.unit[0] = this.detailPc.unit
      if (this.detailPc.unit) {
        this.handleUnit(this.detailPc.unit, 0)
      }
      if (this.detailPc.num) {
        this.updatePurchaseNum(this.detailPc.num, 0)
      }
      if (this.detailPc.fcatName !== "商砼") {
        /* if(this.detailPc.attrList && this.detailPc.attrList.length){
             this.detailPc.attrList.forEach((attr, index)=>{
               this.form.attr[`0-${attr.id}`] = attr.val
               this.formParams.itemList[0].attrList.push({
                 "paramId": attr.id,
                 "paramName": '',
                 "paramValId": attr.valId,
                 "paramValName": attr.val
               })
             })
           } */
        if (this.detailPc.attrList && this.detailPc.attrList.length) {
          this.detailPc.attrList.forEach((attr, index) => {
            this.form.attr[`0-${attr.paramId}`] = attr.paramValName
            this.formParams.itemList[0].attrList.push({
              paramId: attr.paramId,
              paramName: attr.paramName,
              paramValId: attr.paramValId,
              paramValName: attr.paramValName
            })
          })
        }

      } else {
        this.form.strongLevel[0] = this.detailPc.strongLevel
        this.form.config[0] = this.detailPc.config

        this.form.deliveryMethod[0] = this.detailPc.deliveryMethod


        if (
          this.detailPc.admixtureFactList &&
          this.detailPc.admixtureFactList
        ) {
          let admix = []
          this.detailPc.admixtureFactList.forEach((attr, index) => {
            if (!attr.spec) {
              admix[index] = [attr.admixtureName]
            } else {
              admix[index] = [
                attr.admixtureName,
                attr.admixtureName + "-" + attr.spec
              ]
            }
          })
          this.$set(this.selectedAdmix, 0, admix)
          this.admixChange(admix, 0)
        }
        this.handleStrong(this.detailPc.strongLevel, 0)
        this.handleConfig(this.detailPc.config, 0)
        this.handleDeliveryMethod(this.detailPc.deliveryMethod, 0)
      }
      // this.form.publishProvince = Number(this.detailPc.publishProvince)
      setTimeout(() => {
        this.handleBrand(this.detailPc.brandId, 0)
      }, 0)
      if (
        this.detailPc.inviteCompanyList &&
        this.detailPc.inviteCompanyList.length
      ) {
        this.detailPc.inviteCompanyList.forEach(item => {
          this.shopList.push({
            no: item.supplier,
            name: item.supplierName,
            provinceNo: item.provinceNo,
            provinceName: item.provinceName
          })
          let noRepeat = () => {
            let map = new Map()
            for (let item of this.shopList) {
              if (!map.has(item.no)) {
                map.set(item.no, item)
              }
            }
            return [...map.values()]
          }
          this.shopList = noRepeat()
        })
      }
    },
    // 前台商品数据
    async getEnquiryItemDetails() {
      let res = await apiInquiryPrice.getEnquiryItemDetails(
        this.$route.query.id
      )
      if (res.data.code === 200) {
        this.detailPc = res.data.data
        // this.getClassificationsData(Number(res.data.data.publishProvince))
      }
    },
    // 前台商砼数据
    async getEnquiryConcreteDetails() {
      let res = await apiInquiryPrice.getEnquiryConcreteDetails(
        this.$route.query.id
      )
      if (res.data.code === 200) {
        this.detailPc = res.data.data
        // this.getClassificationsData(Number(res.data.data.publishProvince))
      }
    }
  },
  created() {
    this.getClassificationsData()
    this.getUnitListData()
  },
  mounted() {
    // this.getClassificationsData()
    // this.formLoading = true
    /* this.getClassificationsData()
      this.setProvinceNoOptions()
      this.getUnitListData()
      this.getAllAreaList()
      // 如果有no即为编辑
      if(this.$route.query.no){
        this.title='修改询价单'
        this.detailId = this.$route.query.no
        this.formType = 1
        this.getDetailData()
      } else if(this.$route.query.id){
        // type 0 商砼，1商品
        this.title='发布询价单'
        if(this.$route.query.type == 1){
          this.formType = 2
          this.formParams.contacts = this.userInfo.realName
          this.formParams.contactNumber = this.userInfo.telPhone
          this.getEnquiryItemDetails()
        } else {
          this.formType = 3
          this.formParams.contacts = this.userInfo.realName
          this.formParams.contactNumber = this.userInfo.telPhone
          this.getEnquiryConcreteDetails()
        }
      }else {
        this.formParams.contacts = this.userInfo.realName
        this.formParams.contactNumber = this.userInfo.telPhone
        this.formLoading = false
      } */
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    }
  }
}
</script>

<style lang="scss" scoped>
.enquiryDialog {
  overflow: initial;
  z-index: 11;
  /deep/.el-dialog{
    overflow-y: auto;
    height: calc(100vh - 20px);
    margin-bottom: 10px;
  }
  /deep/.el-dialog__header{
      border-bottom: 1px solid #e4e7ed;
    }
  }
.form-inquiry-price {
  h4 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: normal;
  }
  .tooltip {
    color: #666666;
    font-size: 14px;
  }
  .title {
    margin: 20px 0 0 0;
    padding: 0 0 8px 15px;
    border-bottom: 1px dashed #e4e7ed;
    color: #0286df;
    font-size: 18px;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      width: 3px;
      height: 16px;
      top: 4px;
      left: 3px;
      background-repeat: repeat-x;
      background-image: -webkit-linear-gradient(45deg, #0286df, #0286df);
      background-image: -o-linear-gradient(45deg, #0286df, #0286df);
      background-image: linear-gradient(45deg, #0286df, #0286df);
      background: #0286df;
    }
  }
  .form-item-list {
    margin-top: 20px;
    .list-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      label.l-width {
        display: inline-block;
        width: 30px;
        color: #ff6600;
      }
      .setting-title {
        width: 110px;
        text-align: right;
        font-size: 14px;
        i {
          color: #999999;
          cursor: pointer;
        }
      }
      .setting-form {
        flex: 1;
      }
      /*/deep/ .el-upload{
        height: 100px;
        width: 100px;
        line-height: 100px;
        border-radius: 0;
          i{
            font-size: 20px;
            color: #0286DF;
            line-height: 0;
          }
          span{
            color: #969696;
            font-size: 14px;
          }
      }
      /deep/ .el-upload-list__item-actions{
        height: 100px;
        width: 100px;
      }
      /deep/ .el-upload-list__item{
        height: 100px;
        width: 100px;
        img{}
      }*/
      /deep/ .w-300 {
        width: 300px;
        margin-right: 20px;
      }
      /deep/ .w-685 {
        width: 685px;
      }
      /deep/ .w-120 {
        width: 120px;
      }
    }
    .pro-sort-content {
      table {
        border: 1px solid #e4e7ed;
        /*border-collapse: collapse;*/
        tbody {
          position: relative;
          tr {
            border-bottom: 1px solid #e4e7ed;
            td {
              /*border-right: 1px solid #E4E7ED;*/
              border-bottom: 1px solid #e4e7ed;
              padding: 8px;
              &:last-child {
                border-right: 0;
              }
            }
          }
        }
      }
      .div-table-main {
        border: 1px solid #e4e7ed;
        overflow-x: auto;
        /*padding: 8px 0;*/
        .table-list {
          width: 100%;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e4e7ed;
          padding: 8px;
          &:last-child {
            border: 0;
          }
          .list-items {
            /*margin-right: 10px;*/
            display: flex;
            > div {
              margin-right: 10px;
            }
          }
          .btn-td {
            margin-right: 10px;
          }
        }
      }
    }

    .warning-info {
      color: #ff6600;
      font-size: 12px;
      padding-left: 30px;
      /*padding-top: 10px;*/
    }
    .img-tootip {
      color: #969696;
      font-size: 12px;
      /*padding-left: 30px;*/
    }
  }
  /deep/ .el-input__count {
    bottom: 5px !important;
  }
  /deep/ .el-loading-spinner {
    top: 15%;
  }
}
.w-80 {
  width: 80px;
}
.w-100 {
  width: 100px;
}
.w-120 {
  width: 120px;
}
.w-140 {
  width: 140px;
}
.w-160 {
  width: 160px;
}
.w-200 {
  width: 200px;
}
.btn-td {
  /deep/ .el-button {
    color: #ff6600;
    border-color: #ff6600;
    font-weight: bold;
  }
}
.gray {
  color: #999999 !important;
  border-color: #999999 !important;
}
.plus {
  border: 1px dotted #0286df;
  display: inline-block;
  height: 20px;
  width: 20px;
  line-height: 20px;
  color: #0286df;
  margin-right: 10px;
  cursor: pointer;
}
.more {
  color: #0286df;
  font-size: 14px;
  cursor: pointer;
}
.submit-dialog {
  z-index: 99;
  /deep/ .el-dialog {
    .el-dialog__header {
      padding: 15px;
      border-bottom: 1px solid #dfe4ea;
    }
    .el-dialog__body {
      text-align: center;
      i {
        font-size: 57px;
        color: #79bf6e;
      }
      h2 {
        font-size: 16px;
        color: #333333;
      }
      span {
        display: block;
        font-size: 16px;
        color: #969696;
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding: 10px 20px 30px;
    }
  }
}
.start-required {
  &:before {
    padding-right: 5px;
    content: "*";
    color: #ff6600;
  }
}
</style>

